<template>
  <div class="align-middle" :style="{ minWidth: '150px' }">
    <p
      class="text-neutral q-mb-xs"
      :style="{
        display: 'inline-block',
        verticalAlign: 'inherit',
      }"
    >
      {{ col.value || tableProps.value }}
    </p>
    <div class="flex">
      <div class="q-mr-md">
        <p v-if="tableProps.row.hsn" class="text-xxs q-mb-none">
          <span class="text-neutral-70">HSN</span>
        </p>
        <p class="text-xxs q-mb-none">
          <span class="text-neutral-70">GST(%)</span>
        </p>
        <p v-if="!tableProps.row.gst_exempted" class="text-xxs q-mb-none">
          <span class="text-neutral-70">CESS(%)</span>
        </p>
      </div>
      <div>
        <p v-if="tableProps.row.hsn" class="text-xxs q-mb-none">
          <span>{{ tableProps.row.hsn }}</span>
        </p>
        <p class="text-xxs q-mb-none">
          <span v-if="tableProps.row.gst_exempted">Exempted</span>
          <span v-else>{{ tableProps.row.gst }}</span>
        </p>
        <p v-if="!tableProps.row.gst_exempted" class="text-xxs q-mb-none">
          <span>{{ tableProps.row.cess }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  col: {
    type: Object,
    default: () => {
      return {};
    },
  },
  tableProps: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
</script>
